import helper from '../helper'

export const serviceTraffics = {
  get: (token, params) => helper.get('api/v1/traffics', token, params),
  download: (token, params) => helper.get('api/v1/traffics/download', token, params)
}
